import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../Component/Topbar/Topbar";
import { post } from "../redux/api/ApiHandler";
import { URLS } from "../redux/api/Constants";
import ReportPopup from "../../Component/Report/ReportPopup";

const Report = () => {
  const [activeIndex] = useState(null);
  const navigate = useNavigate();
  // const [overallList, setOverallList] = useState();
  const [popup, setPopup] = useState(false);

  const location = useLocation();
  console.log(location.pathname, "pathname");

  let path = location.pathname;

  // const dashboardList = async (val) => {
  //   let res = await post(URLS.DASHBOARD_LIST);
  //   if (res?.status == "success") {
  //     if (res?.overall_ticket) {
  //       setOverallList(res?.overall_ticket);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   // dashboardList();
  // }, []);

  const stats = [
    { label: "Region ", value: 2 },
    { label: "Service Engineer/Tickets ", value: 4 },
    { label: "Tickets  ", value: 4 },
    { label: "Customer  ", value: 3 },
    { label: "Inventory  ", value: 3 },
    { label: "Status  ", value: 3 },
    { label: "Fault Type ", value: 3 },
    { label: "Technical ", value: 3 },
  ].map((i) => ({
    ...i,
    path: path,
  }));

  const handleClick = (index, path, item) => {
    // console.log(index, path, "index, path");
    // setPopup(path)
    // setActiveIndex(index);
    // navigate(path + "?popup=true", { state: { openPopup: index + 1 } });
    let navi = path == "/report" ? "/report-list" : "/report-list-inv";
    // console.log("navi", navi);
    navigate(navi, {
      state: {
        filterType: index + 1,
        popup: item?.value,
        heading: item?.label,
        indexVal: index + 1,
      },
    });
  };

  return (
    <div>
      <Topbar header="Report" />
      <div className="container_fluit1 px-4 py-3">
        <div className="d-flex flex-wrap gap-3 ac-js">
          {stats.map((item, index) => (
            <div
              key={index}
              className={`box_Value d-flex ac-jc ${
                activeIndex === index ? "box_Value_active" : ""
              }`}
              onClick={() => handleClick(index, item.path, item)}
              style={{ cursor: "pointer" }}
            >
              <button
                className="m-0 btn w-100 text-wrap f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20"
                style={{
                  border: "none",
                  background: "transparent",
                  color: activeIndex === index ? "white" : "black",
                }}
              >
                {item.label}
              </button>
            </div>
          ))}
        </div>
        {/* <div className="d-flex flex-wrap gap-3 ac-js">
                    {technicalStats.map((item, index) => (
                        <div
                            key={index}
                            className={`box_Value d-flex ac-jc ${activeIndex === index ? "box_Value_active" : ""
                                }`}
                            onClick={() => handleClick(index, item.path)}
                            style={{ cursor: "pointer" }}
                        >
                            <button
                                className="m-0 btn w-100 text-wrap f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20"
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    color: activeIndex === index ? "white" : "black",
                                }}
                            >
                                {item.label}
                            </button>
                        </div>
                    ))}
                </div> */}
      </div>
      {popup && <ReportPopup popup={popup} setPopup={setPopup} />}
    </div>
  );
};

export default Report;
